function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import SearchPopover from "./searchPopover";
var SearchIconSVG = function SearchIconSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    width: '20px',
    height: '20px',
    viewBox: '0 0 20 20',
    version: '1.1'
  }, /*#__PURE__*/React.createElement("title", null, "icon_\u641C\u7D22"), /*#__PURE__*/React.createElement("g", {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(-1199.000000, -120.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(366.000000, 90.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(823.000000, 26.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(10.000000, 4.000000)'
  }, /*#__PURE__*/React.createElement("rect", {
    x: '0',
    y: '0',
    width: '20',
    height: '20'
  }), /*#__PURE__*/React.createElement("g", {
    transform: 'translate(4.000000, 4.000000)',
    stroke: '#979797',
    strokeLinecap: 'round',
    strokeWidth: '1.5'
  }, /*#__PURE__*/React.createElement("circle", {
    cx: '5.5',
    cy: '5.5',
    r: '5.5'
  }), /*#__PURE__*/React.createElement("line", {
    x1: '10',
    y1: '10',
    x2: '12',
    y2: '12'
  }))))))));
};
var NavSearch = function NavSearch(_ref) {
  var keyword = _ref.keyword,
    handlePostInitialCollect = _ref.handlePostInitialCollect,
    postInitialCollect = _ref.postInitialCollect,
    www = _ref.www,
    image = _ref.image,
    ga = _ref.ga,
    ga4 = _ref.ga4,
    type = _ref.type,
    fixed = _ref.fixed,
    fetchSearchSuggest = _ref.fetchSearchSuggest,
    fetchSearchRecommend = _ref.fetchSearchRecommend;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearch = _useState2[0],
    setShowSearch = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    placeholder = _useState4[0],
    setPlaceholder = _useState4[1];
  useEffect(function () {
    if (Array.isArray(keyword) && keyword.length > 0) {
      var texts = keyword.map(function (item) {
        return item.text;
      }).reverse();
      var index = 0;
      setPlaceholder(texts[index]);
      var interval = setInterval(function () {
        index = (index + 1) % texts.length;
        setPlaceholder(texts[index]);
      }, 5000);
      return function () {
        return clearInterval(interval);
      };
    }
  }, [keyword]);
  var _intervalDuration = function intervalDuration(duration) {
    var dur = duration;
    var setTimeDuration = setInterval(function () {
      dur--;
      if (dur <= 0) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        setTimeDuration && clearInterval(setTimeDuration);
        _intervalDuration(duration.length);
      }
      setPlaceholder(duration[dur]);
    }, 5000);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-search',
    style: {
      color: "#999"
    },
    onClick: function onClick() {
      setShowSearch(true);
      var item = !!keyword.length && keyword.find(function (item) {
        return item.text === placeholder;
      });
      item.ads && postInitialCollect(item.ads, "click");
      document.body.setAttribute("style", "overflow: hidden");
    }
  }, /*#__PURE__*/React.createElement("span", {
    role: 'img',
    "aria-label": 'search',
    className: 'head-anticon'
  }, /*#__PURE__*/React.createElement(SearchIconSVG, null)), !!placeholder && placeholder.trim() || /*#__PURE__*/React.createElement(React.Fragment, null, "\u641C\u5C0B")), /*#__PURE__*/React.createElement(SearchPopover, {
    visible: showSearch,
    www: www,
    image: image,
    ga: ga,
    ga4Collect: ga4,
    type: type,
    isFixed: fixed || false,
    toggle: function toggle() {
      setShowSearch(false);
      document.body.removeAttribute("style");
    },
    fetchSearchSuggest: fetchSearchSuggest,
    postInitialCollect: postInitialCollect,
    fetchSearchRecommend: fetchSearchRecommend
  }));
};
export default NavSearch;